import React, { Component } from 'react'
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import PreloaderTwo from '../components/preloader/PreloaderTwo';
import ExpiredViewQuestionAnswerSectionMiddle from '../components/exams/expired_viewquestion_answer/ExpiredViewQuestionAnswerSectionMiddle';

const FETCH_STUDENTEXAMQUESTION = gql`
  query(
          $mobile: String!, $exam_session_id: Int!,$type: String
$exam_paper_id: Int) {
    
            getStudentExamQuestions(mobile: $mobile, exam_session_id: $exam_session_id,
                type: $type,
                exam_paper_id: $exam_paper_id){
              id
              subject
              examType
              sub_exam_type
              question
              option1
              option2
              option3
              option4
              answer
              qtype
              compquestion
              list1type
              list2type
              mat_question
              explanation
              answer
              inputquestion
              bookmarked
              report{
                report_id
                comments
              }
              notes{
                tags
                comments
              }
              subject_name
              mains_2021
              selection_type
              section_name
              no_of_questions
              no_of_qus_answer
              exam_pattern_id
              no_of_marks
              no_of_neg_marks
              order_by
              indexvalue
              starting_no_val
              ending_no_val
          }
      }
`;





class ExpiredViewQuestionAnswer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            submitError: ""

        }
    }

    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };




    render() {

        if (Cookies.get("studenttoken") == undefined)
        this.props.history.push("/student/login");
        const getStudentExamQuestions = this.props.getStudentExamQuestions;
        const loading1 = getStudentExamQuestions.loading;
        const error1 = getStudentExamQuestions.error;
        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        console.log("getStudentExamQuestions",getStudentExamQuestions);
        


        return (
            <div className={Cookies.get("toggle")}>
                {(loading1 == true ) && (<PreloaderTwo />)}
                {
                    !loading1  && (
                        <ExpiredViewQuestionAnswerSectionMiddle
                            changeToggle={this.menuToggler}
                            getStudentExamSessions={getStudentExamQuestions.getStudentExamQuestions}
                        />
                        
                    )
                }


            </div>
        )
    }
}
export default
    withRouter(
        compose(graphql(FETCH_STUDENTEXAMQUESTION,
                {
                    options: props => ({
                        variables: {
                            mobile: Cookies.get("mobile"),
                            exam_session_id: 0,
                            type: "schedule_exam",
                            exam_paper_id: (props.history.location.state || {}).exam_paper_id
                        }
                        ,
                        fetchPolicy: "cache-and-network"
                    }), name: "getStudentExamQuestions"
                })

        )(ExpiredViewQuestionAnswer));

